<div class="app-register">
  <div class="cp-main">
    <div class="title">{{ 'registration_page_title' | translate }}</div>
    <div class="subtitle">{{ 'registration_page_subtitle' | translate }}</div>

    <form [formGroup]="registerForm" class="cp-m-top-48">

      <div class="cp-columns">
        <div class="cp-column">
          <div class="cp-field">
            <label class="cp-label" for="firstName">{{ 'request_form_name' | translate }}</label>
            <div class="cp-control" [class]="{'error': submitted && !registerForm.get('firstName')?.valid}">
              <input class="cp-input" type="text" formControlName="firstName" id="firstName">
            </div>
          </div>
        </div>

        <div class="cp-column">
          <div class="cp-field">
            <label class="cp-label" for="lastName">{{ 'request_form_surname' | translate }}</label>
            <div class="cp-control" [class]="{'error': submitted && !registerForm.get('lastName')?.valid}">
              <input class="cp-input" type="text" formControlName="lastName" id="lastName">
            </div>
          </div>
        </div>
      </div>

      <div class="cp-field cp-m-top-24">
        <label class="cp-label" for="country">{{ 'country' | translate }}</label>
        <div class="cp-control" [class]="{'error': submitted && !registerForm.get('country')?.valid}">
          <select class="cp-input" formControlName="country" id="country">
            @for (item of countries(); track item.code) {
            <option [value]="item.code">{{ item.name }}</option>
            }
          </select>
          <button class="cp-control-button" style="pointer-events: none;">
            <img src="/assets/img/ic-arrow-down.png"/>
          </button>
        </div>
      </div>

      <div class="cp-field cp-m-top-24">
        <label class="cp-label" for="email">{{ 'email' | translate }}</label>
        <div class="cp-control" [class]="{'error': submitted && !registerForm.get('email')?.valid}">
          <input class="cp-input" type="email" formControlName="email" id="email">
        </div>
      </div>

      <div class="cp-field cp-m-top-24">
        <label class="cp-label" for="confirmEmail">{{ 'request_form_confirm_email' | translate }}</label>
        <div class="cp-control" [class]="{'error': submitted && !registerForm.get('confirmEmail')?.valid}">
          <input class="cp-input" type="email" formControlName="confirmEmail" id="confirmEmail">
        </div>
        @if (submitted && registerForm.get('email')?.valid && registerForm.get('confirmEmail')?.valid && registerForm.hasError('notSameEmail')) {
        <div class="cp-error">
          {{ 'error_confirm_email' | translate }}
        </div>
        }
      </div>

      <div class="cp-field cp-m-top-24">
        <label class="cp-label" for="password">{{ 'password' | translate }}</label>
        <div class="cp-control" [class]="{'error': submitted && !registerForm.get('password')?.valid}">
          <input class="cp-input" [type]="passwordVisible ? 'text' : 'password'" formControlName="password" id="password">
          <button class="cp-control-button" (click)="togglePasswordVisibility()">
            <img src="/assets/img/ic-eye.png"/>
          </button>
        </div>
      </div>

      <div class="cp-field cp-m-top-24">
        <label class="cp-label" for="confirmPassword">{{ 'confirm_password' | translate }}</label>
        <div class="cp-control" [class]="{'error': submitted && !registerForm.get('confirmPassword')?.valid}">
          <input class="cp-input" [type]="confirmPasswordVisible ? 'text' : 'password'" formControlName="confirmPassword" id="confirmPassword">
          <button class="cp-control-button" (click)="toggleConfirmPasswordVisibility()">
            <img src="/assets/img/ic-eye.png"/>
          </button>
        </div>
        @if (submitted && registerForm.get('password')?.valid && registerForm.get('confirmPassword')?.valid) {
          @if (registerForm.hasError('notSamePassword')) {
          <div class="cp-error cp-m-bottom-8">
            {{ 'error_confirm_password' | translate }}
          </div>
          }
          @if (registerForm.hasError('invalidPassword')) {
          <div class="cp-error cp-m-bottom-8">
            {{ 'error_invalid_password' | translate }}
          </div>
          }
        }
        <div class="cp-rules">
          {{ 'registration_page_password_1' | translate }}
          <ul>
            <li>{{ 'registration_page_password_2' | translate }}</li>
            <li>{{ 'registration_page_password_3' | translate }}</li>
            <li>{{ 'registration_page_password_4' | translate }}</li>
            <li>{{ 'registration_page_password_5' | translate }}</li>
          </ul>
          {{ 'registration_page_password_6' | translate }}
        </div>
      </div>

      <div class="disclaimer cp-m-top-24">
        <input type="checkbox" id="myCheckbox1" (click)="clickCheckbox1()" style="display: none;" />
        <label for="myCheckbox1" class="cp-p-right-8">
          @if (clickFirst) {
          <img src="/assets/img/checked.png">
          }
          @else {
          <img src="/assets/img/unchecked.png">  
          }
        </label>
        <span>{{ 'first_condition_1' | translate }} </span>
        <a href="https://s3-eu-west-1.amazonaws.com/com.elite.repository/contratti/app/myetraining/en_contract_v2.html" target="_blank">
          <u>{{'first_condition_2' | translate}}</u>
        </a>
        {{ 'first_condition_3' | translate }} (*)
      </div>

      <div class="disclaimer cp-m-top-8">
        <input type="checkbox" id="myCheckbox2" (click)="clickCheckbox2()" style="display: none;" />
        <label for="myCheckbox2" class="cp-p-right-8">
          @if (clickSecond) {
          <img src="/assets/img/checked.png">
          }
          @else {
          <img src="/assets/img/unchecked.png">  
          }
        </label>
        <span>{{ 'first_condition_1' | translate }} </span>
        <a href="https://s3-eu-west-1.amazonaws.com/com.elite.repository/contratti/app/myetraining/en_privacy_met_v2.html" target="_blank">
          <u>{{ 'second_condition' | translate }}</u>
        </a> (*)
      </div>

      <div class="disclaimer cp-m-top-8">
        <input type="checkbox" id="myCheckbox3" (click)="clickCheckbox3()" style="display: none;" />
        <label for="myCheckbox3" class="cp-p-right-8">
          @if (clickThird) {
          <img src="/assets/img/checked.png">
          }
          @else {
          <img src="/assets/img/unchecked.png">  
          }
        </label>
        <span>{{'third_condition' | translate}}</span>
      </div>

      <button class="coupon-button cp-m-top-24" type="submit" (click)="onSubmit()">
        {{ 'registration_page_title' | translate | uppercase }}
      </button>

    </form>

    <div class="cp-footer cp-m-top-20">
      <span>{{ 'registration_page_elite_id' | translate }}</span>
      <span class="cp-label2" (click)="goToLogin()">{{ 'registration_page_login' | translate }}</span>
    </div>
  </div>
</div>
